import { FormatNumberPipe } from '../../../../../modules/shared/pipes/format-number.pipe';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-swap-success-dialog',
  templateUrl: './swap-success-dialog.component.html',
  styleUrls: ['./swap-success-dialog.component.scss'],
  providers: [FormatNumberPipe],
})
export class SwapSuccessDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SwapSuccessDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public formatNumber: FormatNumberPipe,
  ) {}

  ngOnInit(): void {}

  operationBtnClicked() {
    this.dialogRef.close();
    this.router.navigate(['/history']);
  }

  goDashboard() {
    this.dialogRef.close();
    this.router.navigate(['/grupos']);
  }
}
